/* eslint-disable */
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Axios from "axios";
import Spinner from "../../../components/Spinner/Spinner";
import withErrorHandler from "../../../hoc/withErrorHandler/withErrorHandler";
import * as actions from "../../../store/actions/index";

class CategoriesTable extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubCategoryAdd = this.handleSubCategoryAdd.bind(this);
    this.handleAddProduct = this.handleAddProduct.bind(this);
    this.handleCategoryDelete = this.handleCategoryDelete.bind(this);
    this.handleCategoryNameRename = this.handleCategoryNameRename.bind(this);
    this.handleSubCategoryNameRename =
      this.handleSubCategoryNameRename.bind(this);
    this.handleSubCategoryDelete = this.handleSubCategoryDelete.bind(this);
    this.handleEditSubmit = this.handleEditSubmit.bind(this);

    this.state = {
      newSubCategoryName: "",
      newCategoryName: "",
      updatedSubCategoryName: "",
      category: null,
      categories: null,
      untouchedservices: null,
    };
  }
  componentDidMount() {
    this.props.onFetchCategory();
  }

  componentDidUpdate = () => {
    if (this.props.categories != this.state.categories) {
      this.setState({ categories: this.props.categories });
    }
  };

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  }

  handleAddProduct(e) {
    e.preventDefault();
    let id = e.target.id;
    let categoryName = e.target.name;
    this.props.history.push("./categories/addProducts", {
      id: id,
      categoryName: categoryName,
    });
  }

  handleSubCategoryAdd(e, category) {
    e.preventDefault();
    let newSubCategoryName = this.state.newSubCategoryName;
    if (newSubCategoryName == "") {
      alert("Please enter a valid new category name");
    } else {
      let newCategory = {
        id: category.id,
        newSubCategoryName: newSubCategoryName,
      };
      this.props.onAddSubCategory(newCategory, category);
    }
  }

  handleCategoryDelete(e) {
    e.preventDefault();
    let id = e.target.id;
    this.props.onDeleteCategory(id);
  }

  handleCategoryNameRename(e, id) {
    e.preventDefault();
    let newCategoryName = this.state.newCategoryName;
    if (newCategoryName == "") {
      alert("Please enter a valid new category name");
    } else {
      let editedCategoryName = {
        id,
        categoryName: newCategoryName,
      };
      this.props.onCategoryNameRename(editedCategoryName);
    }
  }

  handleSubCategoryNameRename(e, category, subCategory) {
    e.preventDefault();
    let updatedSubCategoryName = this.state.updatedSubCategoryName;
    if (updatedSubCategoryName.trim() == e.target.name.trim()) {
      return alert("The Category Already Exists");
    }
    if (updatedSubCategoryName == "") {
      alert("Please enter a valid new category name");
    } else {
      let editedCategoryName = {
        id: subCategory.id,
        oldSubCategoryName: subCategory.name,
        subCategoryName: updatedSubCategoryName,
      };
      this.props.onSubCategoryNameRename(editedCategoryName, category);
    }
  }

  handleSubCategoryDelete(e,categoryId) {
    e.preventDefault();
    let id = e.target.id;
    let subCategoryName = e.target.name;
    this.props.onDeleteSubCategory(id, categoryId);
  }

  handleUpload = (e) => {
    let name = e.target.name;
    let category = { ...this.state.category };
    if (typeof category[name] == "string") {
      category[`prev${name}`] = category[name];
    }
    category[name] = e.target.files[0];
    this.setState({ category: category });
  };
  handleChargeType = (e) => {
    let chargeId = e.target.value;
    let chargeType = this.props.chargeTypes.filter(
      (charge) => charge.chargeId == chargeId
    )[0];
    let category = { ...this.state.category };
    category["serviceChargeType"] = chargeType;
    this.setState({ category });
  };

  handleCategoryEdit = (e, id) => {
    // let { name, value } = e.target;
    // let categories = this.state.categories.concat();
    // let category = categories.filter((obj) => obj.id === id)[0];
    // category[name] = value;
    // this.setState({ categories ,category});
    let category = this.state.category;
    category[e.target.name] = e.target.value;
    this.setState({ category: category });
  };

  handleEditSubmit(e) {
    e.preventDefault();
    let category = this.state.category;

    if (category) {
      if (!category.serviceChargeType) {
        return alert("Please Select the charge type");
      } else {
        this.props.onEditService(category);
      }
    } else {
      alert("category is null.");
    }
  }

  getChargeTypeValue = (renderedService) => {
    let category = this.state.category;
    try {
      return category
        ? category.serviceChargeType.chargeId
        : renderedService.serviceChargeType.chargeId;
    } catch (err) {
      return "";
    }
  };
  render() {
    let categories = this.props.categories;

    return (
      <table className="table table-striped table-sm table-responsive">
        <thead>
          <tr className="text-center">
            <th scope="col">#</th>
            <th scope="col">Category</th>
            <th scope="col">SubCategories</th>
            <th scope="col">SubCategory</th>
          </tr>
        </thead>
        {this.props.loading ? (
          <Spinner />
        ) : (
          <tbody>
            {categories &&
              categories.map((category, index) => (
                <tr key={category.id}>
                  <th scope="row">{index + 1}</th>
                  {/* ----------------------- Category Listing starts ----------------------- */}
                  <td>
                    <div className="btn-group">
                      <button
                        type="button"
                        className="btn btn-danger btn-sm dropdown-toggle p-1 px-2 m-0"
                        style={{
                          backgroundColor: "orange",
                        }}
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        {category.categoryName}
                      </button>
                      <div className="dropdown-menu">
                        {/* <button
                          className="dropdown-item"
                          data-toggle="modal"
                          data-target={`#e${category.id}`}
                          onClick={() => this.setState({ category: category })}
                        >
                          Edit
                        </button> */}
                        <button
                          className="dropdown-item"
                          data-toggle="modal"
                          data-target={`#r${category.id}`}
                          onClick={() => this.setState({ category: category })}
                        >
                          Rename
                        </button>

                        {/* {this.props.isAdmin ? ( */}
                        <button
                          className="dropdown-item"
                          data-toggle="modal"
                          data-target={`#d${category.id}`}
                        >
                          Delete
                        </button>
                        {/* ) : null} */}
                      </div>
                    </div>
                    {/* ----------------------- Category Edit Modal starts ----------------------- */}
                    <div
                      className="modal fade bd-example-modal-lg"
                      tabIndex="-1"
                      role="dialog"
                      id={`e${category.id}`}
                      aria-labelledby="exampleModalLabel1"
                      aria-hidden="true"
                    >
                      <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel1">
                              Editing: {category.categoryName}
                            </h5>
                            <button
                              type="button"
                              className="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div className="modal-body">
                            <form
                              onSubmit={(e) =>
                                this.handleEditSubmit(e, category.id)
                              }
                            >
                              <div className="form-row">
                                {/* <div className="form-group col-md-6">
                                  <label htmlFor="categoryName">
                                    Category Name
                                  </label>
                                  <input
                                    type="text"
                                    name="categoryName"
                                    className="form-control"
                                    id="categoryName"
                                    placeholder="Enter Category Name"
                                    onChange={(e) =>
                                      this.handleCategoryEdit(
                                        e,
                                        category.id
                                      )
                                    }
                                    value={category.categoryName}
                                    required
                                  />
                                  </div> */}
                                <div className="form-group col-md-6">
                                  <label htmlFor="serviceLogoUrl">
                                    Upload Category Logo
                                  </label>
                                  <input
                                    type="file"
                                    name="categoryLogoUrl"
                                    className="form-control-file"
                                    id="categoryLogoUrl"
                                    accept=".png,.jpeg, .jpg, .webp"
                                    onChange={this.handleUpload}

                                    // value={category.categoryLogoUrl}
                                  />
                                </div>
                              </div>
                              <div className="form-row">
                                <div className="form-group col-md-12">
                                  <label htmlFor="aboutCategory">
                                    About Category
                                  </label>
                                  <textarea
                                    type="text"
                                    name="aboutCategory"
                                    className="form-control"
                                    id="aboutCategory"
                                    placeholder="Enter Category Description"
                                    rows="3"
                                    onChange={(e) =>
                                      this.handleCategoryEdit(e, category.id)
                                    }
                                    value={category.aboutCategory}
                                    required
                                  />
                                </div>
                              </div>
                              <div className="form-row">
                                <div className="form-group col-md-6">
                                  <label htmlFor="serviceBannerUrl">
                                    Upload Category Banner
                                  </label>
                                  <input
                                    type="file"
                                    name="categoryBannerUrl"
                                    className="form-control-file"
                                    id="categoryBannerUrl"
                                    accept=".png,.jpeg, .jpg, .webp"
                                    onChange={this.handleUpload}

                                    // value={category.serviceBannerUrl}
                                  />
                                </div>
                                <div className="form-group col-md-6">
                                  <label
                                    className="my-1 mr-2"
                                    htmlFor="inlineFormCustomSelectPref"
                                  >
                                    Additional Charges
                                  </label>
                                  <select
                                    name="serviceChargeType"
                                    className="custom-select my-1 mr-sm-2"
                                    // id="inlineFormCustomSelectPref"
                                    id={
                                      category.serviceChargeType
                                        ? category.serviceChargeType.chargeId
                                        : Math.random() * 100000
                                    }
                                    onChange={this.handleChargeType}
                                    value={this.getChargeTypeValue(category)}
                                  >
                                    <option value="">Select...</option>
                                    {this.props.chargeTypes &&
                                      this.props.chargeTypes.map(
                                        (chargeType, index) => (
                                          <option
                                            id={chargeType.chargeId}
                                            key={index}
                                            value={chargeType.chargeId}
                                          >
                                            {chargeType.chargeName}
                                            {/* - ₹{chargeType.chargePrice} */}
                                          </option>
                                        )
                                      )}
                                  </select>
                                </div>
                              </div>
                              <button
                                type="submit"
                                className="btn btn-primary my-1"
                                // onClick={(e) =>
                                //   this.handleEditSubmit(e, category.id)
                                // }
                                disabled={this.props.editServiceBtnLoading}
                              >
                                {this.props.editServiceBtnLoading
                                  ? "Saving"
                                  : "Save"}
                              </button>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* ----------------------- Category Edit Modal ends ----------------------- */}
                    {/* ----------------------- Category Rename Modal starts ----------------------- */}
                    <div
                      className="modal fade"
                      tabIndex="-1"
                      role="dialog"
                      id={`r${category.id}`}
                      aria-labelledby="exampleModalLabel1"
                      aria-hidden="true"
                    >
                      <div className="modal-dialog" role="document">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel1">
                              Currently: {category.categoryName}
                            </h5>
                            <button
                              type="button"
                              className="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div
                            className="modal-body"
                            onSubmit={(e) =>
                              this.handleCategoryNameRename(e, category.id)
                            }
                          >
                            <form className="form-inline">
                              <div className="form-group mx-sm-3 mb-2">
                                <input
                                  type="text"
                                  name="newCategoryName"
                                  className="form-control"
                                  id="inputCategoryName"
                                  placeholder="Update Category name"
                                  onChange={this.handleChange}
                                  required
                                />
                              </div>
                              <button
                                type="submit"
                                className="btn btn-success btn-sm mb-2"
                                id={category.id}
                                // onClick={this.handleCategoryNameRename}
                                disabled={this.props.editCategoryNameLoading}
                              >
                                {this.props.editCategoryNameLoading
                                  ? "Renaming"
                                  : "Save"}
                              </button>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* ----------------------- Category Rename Modal ends ----------------------- */}
                    {/* ----------------------- Category Delete Modal starts ----------------------- */}
                    <div
                      className="modal fade"
                      tabIndex="-1"
                      role="dialog"
                      id={`d${category.id}`}
                      aria-labelledby="exampleModalLabel"
                      aria-hidden="true"
                    >
                      <div className="modal-dialog" role="document">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                              Irreversible operation
                            </h5>
                            <button
                              type="button"
                              className="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div className="modal-body">
                            <p>
                              Are you sure you want to delete '
                              {category.categoryName}' category ?
                            </p>
                          </div>
                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-secondary btn-sm"
                              style={{
                                backgroundColor: "red",
                              }}
                              id={category.id}
                              onClick={this.handleCategoryDelete}
                              disabled={this.props.delCategoryBtnLoading}
                            >
                              {this.props.delCategoryBtnLoading
                                ? "Deleting"
                                : "Delete"}
                            </button>
                            <button
                              type="button"
                              className="btn btn-warning btn-sm"
                              data-dismiss="modal"
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* ----------------------- Category Delete Modal ends ----------------------- */}
                  </td>
                  {/* ----------------------- Category listing ends ----------------------- */}
                  {/* ----------------------- SubCategory listing starts ----------------------- */}
                  <td>
                    {category.subcategories &&
                      category.subcategories.map((subcategory, index) => (
                        <React.Fragment key={index}>
                          <div className="btn-group">
                            <button
                              type="button"
                              className="btn btn-primary btn-sm dropdown-toggle p-1 px-2 m-1"
                              style={{
                                backgroundColor: "black",
                              }}
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              {subcategory.name}
                            </button>
                            <div className="dropdown-menu">
                              <button
                                className="dropdown-item"
                                href="#"
                                id={`${subcategory.id}`}
                                name={subcategory.name}
                                onClick={this.handleAddProduct}
                              >
                                Add Products
                              </button>
                              <button
                                className="dropdown-item"
                                data-toggle="modal"
                                data-target={`#cr${
                                  category.id + subcategory.id
                                }`}
                                name={subcategory.name}
                              >
                                Rename
                              </button>
                              {/* {this.props.isAdmin ? ( */}
                              <button
                                className="dropdown-item"
                                data-toggle="modal"
                                data-target={`#cd${
                                  category.id + subcategory.id
                                }`}
                                name={subcategory.name}
                              >
                                Delete
                              </button>
                              {/* ) : null} */}
                            </div>
                          </div>
                          {/* ----------------------- SubCategory Rename Modal starts ----------------------- */}
                          <div
                            className="modal fade"
                            tabIndex="-1"
                            role="dialog"
                            id={`cr${category.id + subcategory.id}`}
                            aria-labelledby="exampleModalLabel1"
                            aria-hidden="true"
                          >
                            <div className="modal-dialog" role="document">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5
                                    className="modal-title"
                                    id="exampleModalLabel1"
                                  >
                                    Currently: {subcategory.name}
                                  </h5>
                                  <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                  >
                                    <span aria-hidden="true">&times;</span>
                                  </button>
                                </div>
                                <div className="modal-body">
                                  <form
                                    className="form-inline"
                                    onSubmit={(e) =>
                                      this.handleSubCategoryNameRename(
                                        e,
                                        category,
                                        subcategory
                                      )
                                    }
                                  >
                                    <div className="form-group mx-sm-3 mb-2">
                                      <input
                                        type="text"
                                        name="updatedSubCategoryName"
                                        className="form-control"
                                        id="inputSubCategoryName"
                                        placeholder="Update SubCategory name"
                                        onChange={this.handleChange}
                                        required
                                      />
                                    </div>
                                    <button
                                      type="submit"
                                      className="btn btn-success btn-sm mb-2"
                                      style={{
                                        backgroundColor: "green",
                                      }}
                                      id={category.id}
                                      name={subcategory.name}
                                      // onClick={(e)=>this.handleSubCategoryNameRename(e,category)}
                                      disabled={
                                        this.props.editSubCategoryNameLoading
                                      }
                                    >
                                      {this.props.editSubCategoryNameLoading
                                        ? "Renaming"
                                        : "Save"}
                                    </button>
                                  </form>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* ----------------------- SubCategory Rename Modal ends ----------------------- */}
                          {/* ----------------------- SubCategory Delete Modal starts ----------------------- */}
                          <div
                            className="modal fade"
                            tabIndex="-1"
                            role="dialog"
                            id={`cd${category.id + subcategory.id}`}
                            aria-labelledby="exampleModalLabel"
                            aria-hidden="true"
                          >
                            <div className="modal-dialog" role="document">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5
                                    className="modal-title"
                                    id="exampleModalLabel"
                                  >
                                    Irreversible operation
                                  </h5>
                                  <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                  >
                                    <span aria-hidden="true">&times;</span>
                                  </button>
                                </div>
                                <div className="modal-body">
                                  <p>
                                    Are you sure you want to delete '
                                    {subcategory.name}' category ?
                                  </p>
                                </div>
                                <div className="modal-footer">
                                  <button
                                    type="button"
                                    className="btn btn-secondary btn-sm"
                                    style={{
                                      backgroundColor: "red",
                                    }}
                                    id={subcategory.id}
                                    name={subcategory.name}
                                    
                                    onClick={(e)=>this.handleSubCategoryDelete(e,category.id)}
                                    disabled={
                                      this.props.delSubCategoryBtnLoading
                                    }
                                  >
                                    {this.props.delSubCategoryBtnLoading
                                      ? "Deleting"
                                      : "Delete"}
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-warning btn-sm"
                                    data-dismiss="modal"
                                  >
                                    Cancel
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* ----------------------- SubCategory Delete Modal ends ----------------------- */}
                        </React.Fragment>
                      ))}
                  </td>
                  {/* ----------------------- SubCategory listing ends ----------------------- */}
                  {/* ----------------------- Add SubCategory starts ----------------------- */}
                  <td className="text-center">
                    <button
                      className="btn btn-primary btn-sm p-1 px-2 m-0"
                      style={{
                        backgroundColor: "brown",
                      }}
                      data-toggle="modal"
                      data-target={`#sca${category.id}`}
                    >
                      &#9547;
                    </button>
                    <div
                      className="modal fade"
                      id={`sca${category.id}`}
                      tabIndex="-1"
                      role="dialog"
                      aria-labelledby="exampleModalCenterTitle"
                      aria-hidden="true"
                    >
                      <div
                        className="modal-dialog modal-dialog-centered"
                        role="document"
                      >
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5
                              className="modal-title"
                              id="exampleModalLongTitle"
                            >
                              Add SubCategory for {category.categoryName}
                            </h5>
                            <button
                              type="button"
                              className="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div className="modal-body">
                            <form
                              className="form-inline"
                              onSubmit={(e) =>
                                this.handleSubCategoryAdd(e, category)
                              }
                            >
                              <div className="form-group mx-sm-3 mb-2">
                                <input
                                  type="text"
                                  name="newSubCategoryName"
                                  className="form-control"
                                  id="inputCategoryName"
                                  placeholder="Enter subcategory name"
                                  onChange={this.handleChange}
                                  required
                                />
                              </div>
                              <button
                                type="submit"
                                className="btn btn-primary btn-sm mb-2"
                                style={{
                                  backgroundColor: "green",
                                }}
                                id={`${category.id}`}
                                // onClick={(e) =>
                                //   this.handleSubCategoryAdd(e, category)
                                // }
                                disabled={this.props.addSubCategoryBtnLoading}
                              >
                                {this.props.addSubCategoryBtnLoading
                                  ? "Saving"
                                  : "Add"}
                              </button>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                  {/* ----------------------- Add Category ends ----------------------- */}
                </tr>
              ))}
          </tbody>
        )}
      </table>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    categories: state.category.categories,
    loading: state.category.loading,
    addSubCategoryBtnLoading: state.addSubCategory.addSubCategoryBtnLoading,
    delCategoryBtnLoading: state.addCategory.delCategoryBtnLoading,
    editCategoryNameLoading: state.addCategory.editCategoryNameLoading,
    editSubCategoryNameLoading: state.addCategory.editSubCategoryNameLoading,
    delSubCategoryBtnLoading: state.addCategory.delSubCategoryBtnLoading,
    editCategoryBtnLoading: state.addCategory.editCategoryBtnLoading,
    // chargeTypes: state.charges.chargesTypes,
    // isAdmin: state.auth.admin,
  };
}; 

const mapDispatchToProps = (dispatch) => {
  return {
    onFetchCategory: () => dispatch(actions.fetchCategoryAdminWithoutShop()),
    onEditCategory: (category) => dispatch(actions.onEditCategory(category)),
    onAddSubCategory: (newSubCategory, category) =>
      dispatch(actions.onAddSubCategory(newSubCategory, category)),
    onCategoryNameRename: (editedCategoryName) =>
      dispatch(actions.onCategoryNameRename(editedCategoryName)),
    onDeleteCategory: (id) => dispatch(actions.onDeleteCategory(id)),
    onSubCategoryNameRename: (editedSubCategoryName, category) =>
      dispatch(
        actions.onSubCategoryNameRename(editedSubCategoryName, category)
      ),
    onDeleteSubCategory: (id, subCategoryName) =>
      dispatch(actions.onDeleteSubCategory(id, subCategoryName)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withErrorHandler(CategoriesTable, Axios))
);
